module.exports = __webpack_public_path__ + "img/combineService.65855d32.svg";